import { vuexOidcCreateStoreModule } from 'vuex-oidc';

const isDev = process.env.NODE_ENV === 'development';
const identityBaseUrl = 'https://auth.scmks.ru';
const siteBaseUrl = isDev ? 'https://localhost:5010' : 'https://roam.scmks.ru';
export default vuexOidcCreateStoreModule({
	authority: identityBaseUrl,
	clientId: 'roam_site',
	redirectUri: `${siteBaseUrl}/oidc-callback`,
	responseType: 'code',
	scope: 'openid profile roles offline_access',
	popupRedirectUri: `${siteBaseUrl}/oidc-popup-callback`,
	automaticSilentRenew: true,
	silentRedirectUri: `${siteBaseUrl}/silent-renew-oidc.html`,
}, {
	namespaced: true,
});
